(() => {
  'use strict';

  const GA4_MEASUREMENT_ID = 'G-H3JYCTH0VX';

  window.__ES_B2B_TRACKING__ = window.__ES_B2B_TRACKING__ || { version: '2026-08-23-ga4', events: [] };
  document.documentElement.dataset.esB2bTracking = '2026-08-23-ga4';

  const FORM_SELECTOR = '[data-b2b-form="rfq"], #EnjoyStarB2BContact';
  const EVENT_NAMESPACE = 'enjoystar:b2b-event';

  function analyticsAllowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed()
      );
    } catch (_) {
      return false;
    }
  }

  function loadGa4IfAllowed() {
    if (!analyticsAllowed() || window.__ES_GA4_LOADED__) return;

    window.__ES_GA4_LOADED__ = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
    });
    window.gtag('js', new Date());
    window.gtag('config', GA4_MEASUREMENT_ID);

    const tag = document.createElement('script');
    tag.async = true;
    tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA4_MEASUREMENT_ID);
    tag.dataset.enjoystarGa4 = GA4_MEASUREMENT_ID;
    document.head.appendChild(tag);
    document.documentElement.dataset.esGa4 = GA4_MEASUREMENT_ID;
  }

  function cleanPath(value) {
    try {
      const parsed = new URL(value, window.location.origin);
      return parsed.origin === window.location.origin ? parsed.pathname : parsed.hostname + parsed.pathname;
    } catch (_) {
      return '';
    }
  }

  function oncePerSession(key) {
    try {
      if (window.sessionStorage.getItem(key)) return false;
      window.sessionStorage.setItem(key, '1');
    } catch (_) {}
    return true;
  }

  function emit(name, parameters = {}) {
    const payload = {
      event_category: 'B2B lead',
      page_path: window.location.pathname,
      page_title: document.title,
      ...parameters,
    };

    if (analyticsAllowed()) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...payload });
      }

      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, payload);
        }
      } catch (_) {}
    }

    window.__ES_B2B_TRACKING__.events.push({ name, parameters: payload });
    document.documentElement.dataset.esB2bLastEvent = name;
    document.dispatchEvent(new CustomEvent(EVENT_NAMESPACE, { detail: { name, parameters: payload } }));
  }

  function getProductContext() {
    const productMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return productMatch ? productMatch[1] : '';
  }

  loadGa4IfAllowed();
  document.addEventListener('visitorConsentCollected', loadGa4IfAllowed);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const label = (link.textContent || '').trim().slice(0, 80);
    const productHandle = getProductContext();

    if (/wa\.me|whatsapp\.com/i.test(href)) {
      emit('whatsapp_click', {
        link_location: cleanPath(window.location.href),
        link_label: label,
        product_handle: productHandle,
        lead_channel: 'whatsapp',
      });
      return;
    }

    if (/mailto:/i.test(href)) {
      emit('b2b_email_click', {
        link_location: cleanPath(window.location.href),
        link_label: label,
        product_handle: productHandle,
        lead_channel: 'email',
      });
      return;
    }

    if (/\/pages\/contact(?:[?#]|$)/i.test(href)) {
      emit('b2b_quote_click', {
        link_location: cleanPath(window.location.href),
        link_label: label,
        product_handle: productHandle,
        lead_channel: 'rfq_form',
      });
    }
  });

  document.addEventListener('focusin', (event) => {
    const form = event.target.closest(FORM_SELECTOR);
    if (form && oncePerSession('es_b2b_inquiry_start')) {
      emit('b2b_inquiry_start', { form_id: form.id || 'rfq' });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;
    const buyerType = form.querySelector('[name="contact[Buyer Type]"]');
    emit('b2b_inquiry_submit', {
      form_id: form.id || 'rfq',
      buyer_type: buyerType ? buyerType.value : '',
      has_company: Boolean(form.querySelector('[name="contact[Company Name]"]')?.value),
      has_quantity: Boolean(form.querySelector('[name="contact[Quantity]"]')?.value),
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector(FORM_SELECTOR);
    if (form) {
      const productField = form.querySelector('#EnjoyStarProductPageUrl');
      const productInterest = form.querySelector('[name="contact[Product Interested]"]');
      const referrerPath = cleanPath(document.referrer);
      if (productField && /\/products\//.test(referrerPath)) productField.value = document.referrer;
      if (productInterest && !productInterest.value && /\/products\//.test(referrerPath)) {
        productInterest.value = referrerPath.split('/products/')[1].replace(/-/g, ' ');
      }
    }

    const successful = document.querySelector('.es-contact__success') || new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    if (successful && oncePerSession('es_b2b_inquiry_success_' + window.location.pathname)) {
      emit('generate_lead', { lead_channel: 'rfq_form', form_id: 'EnjoyStarB2BContact' });
      emit('b2b_inquiry_success', { lead_channel: 'rfq_form', form_id: 'EnjoyStarB2BContact' });
    }
  });
})();